document.addEventListener('DOMContentLoaded', function() {
    $('.marquee-row').slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
});


// tab-collections tab-collections__slider
document.querySelectorAll('.tab-collections__panel').forEach((wrapper) => {
  collectionTabSlider(wrapper);
});


function collectionTabSlider(wrapper){
  const slider = wrapper.querySelector('.tab-collections__slider');
  const slides = parseInt(slider.getAttribute('data-slides')) || 4;
  const loop = slider.getAttribute('data-loop') === 'true';
  const autoplayDelay = parseInt(slider.getAttribute('data-autoplay'));
  const paginationEnabled = slider.getAttribute('data-pagination') === 'true';
  const navigationEnabled = slider.getAttribute('data-navigation') === 'true';
  const sectionId = slider.getAttribute('data-section') || "";
  const mobileSlide = parseInt( slider.getAttribute('data-mobile-slide') ) || 1 ;
  const tablateSlide = parseInt( slider.getAttribute('data-tablet-slide') ) || 2 ;


    new Swiper(slider, {
      slidesPerView: slides,
      loop: loop,
      spaceBetween: 20,

      pagination: paginationEnabled ? {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,

      
      navigation: {
        nextEl: wrapper.querySelector(`.custom-next-${sectionId}`),
        prevEl: wrapper.querySelector(`.custom-prev-${sectionId}`),
      },

      breakpoints: {
        320: { slidesPerView: mobileSlide },
        768: { slidesPerView: tablateSlide },
        1024: { slidesPerView: slides }
      }
    });
}
document.querySelectorAll('.tab-collections').forEach((wrapper) => {

  const tabs = wrapper.querySelectorAll('.tab-collections__tab');
  const panels = wrapper.querySelectorAll('.tab-collections__panel');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {

      const target = tab.dataset.tab;


      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));

      tab.classList.add('active');

      const activePanel = wrapper.querySelector(`.tab-collections__panel[data-panel="${target}"]`);
      activePanel.classList.add('active');

      // const swiperEl = activePanel.querySelector('.tab-collections__slider');

          setTimeout(function(){
      collectionTabSlider(activePanel);
      },500);

    });
  });

});